import { Flex } from 'antd/lib'
import { MarkdownViewIcon } from 'Components/common/Icons/MarkdownViewIcon'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'
import classes from 'Tasks/CustomTask/UI/common/PromptGeneration/PromptGeneration.module.less'
import React, { useMemo } from 'react'
import { useDebouncedValue } from 'shared/hooks/use-debounced-value'

type MarkdownPreviewProps = {
    content?: string
}

const MarkdownPreviewComponent: React.FC<MarkdownPreviewProps> = ({ content }) => {
    const debouncedContent = useDebouncedValue(content, 200)

    const preview = useMemo(() => {
        const trimmed = debouncedContent?.trim()
        return trimmed ? (
            <MarkdownRenderer escapeBackslashses>{trimmed}</MarkdownRenderer>
        ) : (
            <Flex gap={8} justify="center" align="center">
                <MarkdownViewIcon />
                <div className={classes.markdownViewLabel}>Markdown view</div>
            </Flex>
        )
    }, [debouncedContent])

    return preview
}

export default MarkdownPreviewComponent
